import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: "highlight"
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, search): string {
    if (search && text) {
      const pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&").trim();
      const regex = new RegExp(pattern, "gi");
      return text.replace(regex, match => `<strong>${match}</strong>`);
    } else {
      return text;
    }
  }
}
